<template>
  <div>
    <h4 class="hide-on-small-only">
      {{ id ? "Editar Questão" : "Nova Questão" }}
    </h4>
    <div class="card-panel" style="margin-bottom: 24px">
      <form @submit.prevent="save">
        <div class="row">
          <div class="col s12" style="padding: 0 !important">
            <div class="row">
              <div class="input-field col s12 m6">
                <label for="question">Titulo</label>
                <input
                  type="text"
                  name="question"
                  id="question"
                  v-model="form.question"
                  v-validate="'required|min:3'"
                  :class="{ invalid: errors.first('question') }"
                />
                <span
                  class="helper-text"
                  :data-error="errors.first('question')"
                ></span>
              </div>
              <div class="input-field col s12 m6">
                <select v-model="form.type_response">
                  <option value disabled selected
                    >Selecione tipo de resposta</option
                  >
                  <option
                    class="left"
                    :value="typeResp.value"
                    v-for="typeResp in typesResponse"
                    :key="typeResp.id"
                    >{{ typeResp.title }}</option
                  >
                </select>
                <span
                  class="helper-text"
                  v-show="formErros.typeResponse"
                  style="color: #F44336;"
                  >{{ formErros.typeResponse }}</span
                >
              </div>
            </div>

            <div class="row">
              <div class="col s12 m6">
                <!-- TODO: Verify label -->
                <VToggle
                  label="Confirmar para preenchimento de resposta"
                  :checked="this.form.has_confirmation"
                  @input="event => (this.form.has_confirmation = event)"
                />
              </div>
            </div>

            <div class="row" v-show="isRespCad">
              <div class="col s12">
                <div class="box-title">
                  <h6>
                    Adicione alternativas para resposta.
                    <b>total - {{ form.response.length }}</b>
                  </h6>

                  <div class="divider" />

                  <span class="error" v-show="formErros.lengthReps">{{
                    formErros.lengthReps
                  }}</span>
                </div>

                <div class="box-add-option">
                  <img :src="typeSelect" alt />
                  <input
                    type="text"
                    v-model="respAdd"
                    placeholder="Digite aqui para adicionar uma nova resposta."
                    @keypress.prevent.enter="addResp"
                  />
                </div>

                <div
                  class="box-options"
                  v-for="(resp, indice) in form.response"
                  :key="resp"
                >
                  <div>
                    <img :src="typeSelect" alt />
                    <p>{{ resp }}</p>
                  </div>
                  <a class="btn btn-icon" @click.prevent="removeResp(indice)">
                    <i class="material-icons">delete</i>
                  </a>
                </div>
              </div>
            </div>
            <div v-show="!isRespCad">
              <div class="box-example" v-show="isExampleResp">
                <div class="row">
                  <div class="col s12">
                    <p>Exemplo:</p>
                  </div>
                </div>
                <div class="row" v-if="form.type_response === 'LONG_ANSWER'">
                  <div class="input-field col s12">
                    <textarea
                      id="example-long-text"
                      class="materialize-textarea disabled"
                      data-length="120"
                    ></textarea>
                    <label for="example-long-text">Parágrafo</label>
                    <span
                      class="character-counter"
                      style="float: right; font-size: 12px;"
                      >0/120</span
                    >
                  </div>
                </div>
                <div
                  class="row"
                  v-else-if="form.type_response === 'SHORT_ANSWER'"
                >
                  <div class="input-field col s12 m6">
                    <input id="input_text" type="text" disabled />
                    <label for="input_text">Respota curta</label>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col s12 m8">
                    <div class="row">
                      <div class="col s6 m3">
                        <button
                          class="waves-effect btn-large flat"
                          @click.prevent
                        >
                          Não
                        </button>
                      </div>
                      <div class="col s6 m3">
                        <button
                          class="waves-effect waves-light btn-large"
                          @click.prevent
                        >
                          Sim
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="box-linear-scale"
                v-show="form.type_response === 'LINER_SCALE'"
              >
                <div class="row">
                  <div class="col s12">
                    <p>Selecione a escala linear que deseja:</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col s12 m10">
                    <div class="row">
                      <div class="col s5 m3 l2">
                        <select
                          name="first-linear-scale"
                          v-model="rangeLinearScale.first"
                        >
                          <option :value="1">1</option>
                        </select>
                      </div>
                      <div class="col s2 m1">
                        <p class="center">
                          <b>a</b>
                        </p>
                      </div>
                      <div class="col s5 m3 l2">
                        <select
                          name="last-linear-scale"
                          v-model="rangeLinearScale.last"
                        >
                          <option :value="5">5</option>
                          <option :value="10">10</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actions">
          <router-link
            class="waves-effect btn-large flat form-button"
            stag="a"
            :to="{ name: 'questions' }"
            >voltar</router-link
          >
          <div class="spacer"></div>
          <button
            class="waves-effect waves-light btn-large form-button"
            type="submit"
            :class="{ load: load }"
          >
            <feather v-if="load" type="loader" animation="spin" />
            <template v-else>{{ id ? "salvar" : "Cadastrar" }}</template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "QuestionCreteOrUpdate",
  components: {
    VToggle: () => import("@/components/VToggle")
  },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    load: false,
    instanceSelect: {},
    respAdd: "",
    formErros: {
      typeResponse: "",
      lengthReps: ""
    },
    rangeLinearScale: {
      first: 0,
      last: 5
    },
    typesResponse: [
      {
        id: 1,
        value: "BOOLEAN",
        title: "Condicional (Sim ou Não)"
      },
      {
        id: 2,
        value: "SHORT_ANSWER",
        title: "Resposta curta"
      },
      {
        id: 3,
        value: "LONG_ANSWER",
        title: "Parágrafo (Texto)"
      },
      {
        id: 5,
        value: "CHECK_BOXES",
        title: "Múltipla escolha"
      },
      {
        id: 6,
        value: "LINER_SCALE",
        title: "Escala linear"
      },
      {
        id: 7,
        value: "CHOICES",
        title: "Escolha única"
      }
    ],
    form: {
      question: "",
      type_response: "",
      response: [],
      has_confirmation: false
    }
  }),
  mounted() {
    const el = this.$el.querySelectorAll("select");
    this.instanceSelect = M.FormSelect.init(el);

    if (this.id) {
      this.getQuestion();
    }
  },
  watch: {
    "form.type_response": function validateTypeResponse(value) {
      this.form.response = [];
      if (this.form.type_response) {
        if (this.$el.querySelector(".select-dropdown")) {
          this.$el.querySelector(".select-dropdown").classList.remove("error");
          this.formErros.typeResponse = "";
        }
      }
    },
    "form.response": function validateResponse(value) {
      if (value.length > 1) {
        this.formErros.lengthReps = "";
      }
    }
  },
  computed: {
    ...mapState("User", ["token"]),
    typeSelect() {
      if (this.form.type_response) {
        return this.typesResponse.filter(
          value => value.value === this.form.type_response
        )[0].icon;
      }
      return false;
    },
    isRespCad() {
      // eslint-disable-next-line camelcase
      const { type_response } = this.form;

      return (
        // eslint-disable-next-line camelcase
        type_response === "CHOICES" ||
        // eslint-disable-next-line camelcase
        type_response === "CHECK_BOXES" ||
        // eslint-disable-next-line camelcase
        type_response === "DROPDOWN"
      );
    },
    isExampleResp() {
      // eslint-disable-next-line camelcase
      const { type_response } = this.form;

      return (
        // eslint-disable-next-line camelcase
        type_response === "SHORT_ANSWER" ||
        // eslint-disable-next-line camelcase
        type_response === "LONG_ANSWER" ||
        // eslint-disable-next-line camelcase
        type_response === "BOOLEAN"
      );
    }
  },
  methods: {
    async getQuestion() {
      const loader = this.$loading.show({
        loader: "spinner",
        width: 50,
        backgroundColor: "#000",
        color: "#fff"
      });

      try {
        const response = await this.$http.get(
          `questions?search=uuid:${this.id}`
        );
        const [question] = response.body.data.questions;

        this.instanceSelect.forEach(value => value.destroy());
        this.form.type_response = question.type_response;
        this.form.question = question.question;
        this.form.has_confirmation = question.has_confirmation;

        this.$nextTick(() => {
          this.form.response = question.response;
        });

        setTimeout(() => {
          this.instanceSelect = M.FormSelect.init(
            this.$el.querySelectorAll("select")
          );
          this.$el.querySelector("label").classList.add("active");
        }, 0);
      } catch (e) {
        console.error(e);
      }

      loader.hide();
    },
    async save() {
      await this.$validator.validateAll();

      if (!this.form.type_response) {
        this.$el.querySelector(".select-dropdown").classList.add("error");
        this.formErros.typeResponse = "Prenchimento obrigatório";
      }

      if (this.isRespCad && !(this.form.response.length > 1)) {
        this.formErros.lengthReps = "Adicione no mínimo 2 resposta";
      }

      if (
        !this.errors.items.length > 0 &&
        this.form.type_response &&
        !(this.isRespCad && !(this.form.response.length > 1))
      ) {
        if (this.form.type_response === "LINER_SCALE") {
          this.form.response.push(this.rangeLinearScale.first);
          this.form.response.push(this.rangeLinearScale.last);
        }

        this.load = true;

        try {
          let msg;

          if (!this.id) {
            await this.$http.post(
              "questions",
              {
                questions: [
                  {
                    ...this.form
                  }
                ]
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );

            msg = "Cadastro efetuado com sucesso";
          } else {
            await this.$http.post(
              `questions/${this.id}`,
              {
                question: {
                  ...this.form
                }
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );

            msg = "Questão alterada com sucesso";
          }

          this.$swal({
            title: "Pronto!",
            text: msg,
            icon: "success",
            buttons: {
              cancel: false,
              GoList: {
                text: "Ir para Listagem",
                value: "GO_LIST",
                className: "waves-effect btn-large flat"
              },
              confirm: {
                text: "Novo Cadastro",
                value: "NEW_CAD",
                className: "waves-effect waves-light btn-large"
              }
            }
          }).then(val => {
            if (val === "NEW_CAD") {
              this.instanceSelect.forEach(value => value.destroy());

              Object.assign(this.$data, this.$options.data());

              setTimeout(() => {
                this.instanceSelect = M.FormSelect.init(
                  this.$el.querySelectorAll("select")
                );
                this.$el.querySelector("label").classList.remove("active");
              }, 0);
            }

            if (val === "GO_LIST") {
              this.$router.push({ name: "questions" });
            }
          });
        } catch (e) {
          M.toast({
            html: e.body.message,
            displayLength: 5000
          });
        }
        this.load = false;
      }
    },
    addResp(e) {
      if (!this.form.response.some(value => value.includes(this.respAdd))) {
        this.form.response.push(this.respAdd);
      }
      this.respAdd = "";
    },
    removeResp(e) {
      this.form.response.splice(e, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

button {
  @media #{$small-and-down} {
    width: 100%;
  }
}

.row {
  margin-bottom: 0 !important;
}
.actions {
  display: flex;
  justify-content: flex-end;
  .spacer {
    width: 16px;
    height: 24px;
  }

  @media #{$small-and-down} {
    flex-direction: column-reverse;
  }
}
.box-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    margin-bottom: 16px;
    width: 200px;

    @media #{$small-and-down} {
      width: 100%;
    }
  }
}
.border-error {
  border: 2.4px solid #f44336;
}
.dropdown-content li > a,
.dropdown-content li > span {
  i {
    color: #2364a2;
    margin-right: 16px;
  }
}

.box-add-option {
  display: flex;
  align-items: center;
  margin: 32px 0;
  img {
    margin-right: 16px;
  }
}
.box-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  div {
    display: flex;
    img {
      margin-right: 16px;
    }
    p {
      word-break: break-all;
      margin-right: 16px;
    }
  }
}
@media #{$small-and-down} {
  .card-panel {
    min-height: calc(100vh - (56px + 14px));
    display: flex;
    form {
      display: flex;
      flex-direction: column;
      min-height: 100%;
      .actions {
        margin-top: auto;
      }
    }
  }
}
textarea.disabled {
  height: 80px;
  opacity: 0.5;
  pointer-events: none;
}

.box-title {
  h6 {
    margin-bottom: 16px;
  }
  .divider {
    margin-bottom: 8px;
  }
  span.error {
    position: relative;
    color: #f44336;
    min-height: 18px;
    display: block;
    font-size: 12px;
  }
}

.box-linear-scale {
  margin-bottom: 32px;
}
</style>
<style lang="scss">
.select-dropdown.error {
  border-bottom: 1px solid #f44336 !important;
  box-shadow: 0 1px 0 0 #f44336 !important;
}
.swal-footer {
  display: flex;
  justify-content: space-around;
}
</style>
